import { render, staticRenderFns } from "./Opsiyonlar.vue?vue&type=template&id=7b1ca07f&scoped=true&"
import script from "./Opsiyonlar.vue?vue&type=script&lang=js&"
export * from "./Opsiyonlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ca07f",
  null
  
)

export default component.exports